import { UserLoggedInNavigatorNavigationProp } from "@/src/TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { CompositeNavigationProp, RouteProp } from "@react-navigation/native";
import {
  createNativeStackNavigator,
  NativeStackNavigationProp,
} from "@react-navigation/native-stack";

type AccountEditParamList = {
  AccountEditScreen: { id: string; storeId?: string };
  AccountEditRoleScreen: { id: string; storeId?: string };
  AccountEditConnectEmployeeScreen: { id: string; storeId?: string };
};

export const AccountEditStack =
  createNativeStackNavigator<AccountEditParamList>();

export type AccountEditScreenProps<T extends keyof AccountEditParamList> = {
  route: RouteProp<AccountEditParamList, T>;
  navigation: CompositeNavigationProp<
    NativeStackNavigationProp<AccountEditParamList, T>,
    UserLoggedInNavigatorNavigationProp<"AccountEdit">
  >;
};
